{
  "settings": "Seaded",
  "yourDigitalAssistant": "Teie digitaalne assistent",
  "getStarted": "Alustama",
  "login": "Logi sisse",
  "loggingIn": "Sisse logima ...",
  "darkMode": "Tume režiim",
  "clearHistory": "Kustusta ajalugu",
  "historyCleared": "Ajalugu kustutatud",
  "changeLanguage": "Keel",
  "termsAndConditions": "Kasutustingimused",
  "messagePlaceholder": "Sisestage oma sõnum siia ...",
  "messagePlaceholderDisabled": "Sisestamine keelatud ...",
  "feedbackTitle": "Hinnake oma kogemusi",
  "feedbackPlaceholder": "Räägi meile sellest (valikuline)",
  "feedbackSend": "Saada",
  "feedbackClose": "Sulge",
  "sessionExpired": "Teie seanss on passiivsuse tõttu aegunud.",
  "startNewSession": "Alustage uut seanssi",
  "apiError": "Vabandust! Midagi läks valesti. Me töötame, et see saaks parandatud niipea, kui võimalik.",
  "apiErrorOffline": "Teil pole Interneti-ühendust.",
  "tryAgain": "Proovi uuesti",
  "startOver": "Alusta uuesti",
  "chatEnded": "Vestlus on lõppenud.",
  "chatEndedThankYou": "Täname, et meiega vestlesite!",
  "closeChat": "Sulge",
  "startNewChat": "Vestelge uuesti",
  "humanTakeoverStarted": "Teid suunatakse nüüd klienditeenindusse ...",
  "humanTakeoverQueued": "Agendiga ühenduse loomise ootel",
  "humanTakeoverAnAgent": "Agent",
  "humanTakeoverAgentEntered": "sisenes vestlusesse",
  "humanTakeoverAgentLogout": "lahkus vestlusest",
  "humanTakeoverTransfer": "Teid suunatakse uuele agendile",
  "humanTakeoverEnded": "Vestlete nüüd oma digitaalse assistendiga",
  "version": "Versioon",
  "formIntroText": "Meiega vestlemise alustamiseks täitke järgmine vorm.",
  "formFirstName": "Eesnimi",
  "formLastName": "Perekonnanimi",
  "formName": "Nimi",
  "formEmail": "E-post",
  "formWrongEmail": "Palun sisestage kehtiv e-posti aadress.",
  "formPhone": "Telefon",
  "formShipmentId": "Saadetise ID",
  "formQuestion": "Teie küsimus",
  "formAccountNumber": "Konto number (äriklientidele)",
  "formAddress": "Aadress",
  "formPostcode": "Postiindeks",
  "formCity": "Linn",
  "formCountry": "Riik",
  "formSubmitButton": "Alustage vestlust",
  "formEmptyFieldError": "Ei tohi olla tühi.",
  "formPhoneNumberValidationError": "Kehtetu telefoninumber.",
  "formInputIsBiggerThan50": "Võib olla maksimaalselt 50 tähemärki.",
  "formInputIsBiggerThan100": "Võib olla maksimaalselt 100 tähemärki.",
  "formInputIsBiggerThan2000": "Võib olla maksimaalselt 2000 tähemärki.",
  "widgetEventOnline": "DA sõnum: kasutaja on uuesti võrgus.",
  "widgetEventHidden": "DA sõnum: vidin on peidetud.",
  "widgetEventVisible": "DA sõnum: vidin on nähtav.",
  "widgetEventVisibleMinimized": "DA sõnum: vidin on nähtav, kuid minimeeritud.",
  "widgetEventMinimized": "DA sõnum: vidin on viidud miinimumini.",
  "widgetEventMaximized": "DA sõnum: vidin on maksimeeritud.",
  "widgetEventSessionExpired": "DA sõnum: vidina seanss on aegunud.",
  "widgetEventHangupHuman": "DA -teade: kasutaja lõpetab inimese ülevõtmise seansi.",
  "widgetEventUserTyping": "DA-teade: kasutaja kirjutab.",
  "fileTooLarge": "Püüate manustada liiga suuri faile.",
  "tooManyDiles": "Püüate manustada liiga palju faile.",
  "fileInvalidType": "Püüate manustada valesid failitüüpe.",
  "attachmentsDropHere": "Vajutage siia üleslaadimiseks või",
  "attachmentsBrowse": "Sirvige faile",
  "attachmentsExtenstionQuantity": "pdf või pildid (kuni 10 faili)",
  "attachmentsSize": "kuni 30 MB",
  "attachmentsFailedUploading": "Üleslaadimine ebaõnnestus",
  "attachmentsUploading": "Üleslaadimine ...",
  "minimizeExpandText": "Vestelge meiega nüüd otseülekandes!",
  "popupWidgetNotificationMessage": "Saite uue sõnumi!",
  "tabWidgetNotificationMessage": "Uus sõnum!",
  "datepickerSendButton": "Saada"
}
